import { ActionArgs } from '../action/ActionArgs'
import { Field, InputType } from 'type-graphql'

@InputType()
export class GetSettingAppSettingServiceArgs extends ActionArgs {
  @Field(() => String, { nullable: true })
  key?: string

  @Field(() => String, { nullable: true })
  scopeName?: string

  @Field(() => String, { nullable: true })
  settingName?: string

  @Field(() => String, { nullable: true })
  scopeKey?: string
}
